/* @flow */

export { filterSearchList } from './ListUtils';

export { getCountForTables } from './CountUtils';

export { getFromLocalStorage, removeFromLocalStorage, saveToLocalStorage } from './LocalStorage';
/**
 * Find if object has a sequence of accessible properties.
 * Use this to avoid long if statement like: obj && obj.attr && obj.attr.attr ...etc.
 *
 * Example:
 * has(assetDetails, 'location.company');
 *    VS
 * assetDetails && assetDetails.location && assetDetails.location.company
 *
 * @param obj
 * @param literal
 * @returns {boolean}
 */
export const has = (obj, literal) => {
  const props = literal.split('.');

  let _obj = obj;
  try {
    props.forEach((item, i) => {
      _obj = _obj[item];
      if (!_obj[item]) throw new Error('NO');

      // try {
      //   console.log(_obj[item]);
      // } catch (e) {
      //   console.log("Error", e);
      //   throw new Error("NO");
      //   return false;
      // }
    });

    return true;
  } catch (e) {
    return false;
  }
};
